(function stopAreaListPage() {
  const stopAreaListPageContainer: HTMLElement | null = document.getElementById('stop-area-list-page');
  if (stopAreaListPageContainer) {
    class StopAreaListPage {
      public init() {
        window.addEventListener('hashchange', (e) => {
          e.preventDefault();
          setTimeout(() => {
            const navigationCharacter = window.location.hash.replace('#', '');
            const element = document.getElementById(navigationCharacter.toUpperCase()) as HTMLElement;
            if (element) {
              element.scrollIntoView();
              element.focus();
            }
          }, 2000);
        });
      }
    }
    const page = new StopAreaListPage();
    page.init();
  }
})();
